import React from "react";

interface AbaMinhasPendenciasProps {}

export const AbaMinhasPendencias: React.FC<AbaMinhasPendenciasProps> = (props) => {
  return <h1>Aba Minhas Pendencias</h1>;
};
